import { render, staticRenderFns } from "./Documentary.vue?vue&type=template&id=c2b29908&scoped=true"
import script from "./Documentary.vue?vue&type=script&lang=js"
export * from "./Documentary.vue?vue&type=script&lang=js"
import style0 from "./Documentary.vue?vue&type=style&index=0&id=c2b29908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b29908",
  null
  
)

export default component.exports